/**
 * 首页 / More 页 Referral 角标：仅使用 vip-progress 的 currentVipLevel，无有效值则不展示。
 */
export function levelForReferralCornerBadge(vip) {
  if (!vip || typeof vip !== "object") return null;
  const raw = vip.currentVipLevel;
  if (raw == null || raw === "") return null;
  const n = Number(raw);
  if (!Number.isFinite(n)) return null;
  const level = Math.floor(n);
  if (level < 1) return null;
  return Math.min(5, level);
}
